const statistical = {
  isSelect: "Please select the data to package",
  noSuccess: "Download failed",
  operation: {
    month: "วันที่",
    aperationMileage: "ระยะทาง (ก.ม.)",
    aperationTiemLenthen: "ระยะเวลา (นาที)",
    oil: "การใช้น้ำมัน (ลิตร)",
    oilPay: "ค่าน้ำมัน(บาท)",
    carbonEmission: "ปริมาณคาร์บอน (ก.ก.)",
    licenseplate: "Please enter the license plate number",
    searchWidth: {
      width1: "85px",
      width2: "50px",
      width3: "65px"
    },
    allAperationMileage: "Total operating mileage",
    allAperationTiemLenthen: "Total operating time",
    allOil: "Total fuel consumption",
    tripCount: "จำนวนเที่ยว",
    score: "คะแนนพฤติกรรมการขับรถ",
    sharpturn: "เลี้ยวกะทันหัน (ครั้ง)",
    emergencyBrake: "เร่งกะทันหัน (ครั้ง)",
    rapidAcceleration: "เบรคกะทันหัน (ครั้ง)  ",
    emergencyBrakeWidth: "200px",
    rapidAccelerationWidth: "200px",
    sharpturnWidth: "200px"
  },
  hisDownloadSearch: {
    missionName: "ชื่องาน",
    downloadType: "ประเภทการดาวน์โหลด",
    downloadStatus: "สถานะการดาวน์โหลด",
    searchLabelWidth: "125px",
    searchLabelWidth1: "65px",
    searchTitle: "ดาวน์โหลดรายการงานย่อย",
    downloadPackage: "ดาวน์โหลดแพ็คเกจ"
  },
  hisDownloadTabel: {
    taskType: "ประเภทงาน",
    downloadedVehicles: "ดาวน์โหลดยานพาหนะ",
    downloadProgress: "ดาวน์โหลดความคืบหน้า",
    downloader: "ผู้สร้าง",
    taskCreationTime: "เวลาในการสร้างงาน",
    instructions: "Instructions",
    start: "การเริ่มต้น",
    queue: "เข้าแถว",
    processing: "กำลังประมวลผล",
    compressing: "การบีบอัด",
    completed: "เสร็จเรียบร้อย",
    abnormal: "ผิดปกติ",
    noHistoricalData: "ไม่มีข้อมูลในอดีต",
    commonTasks: "งานทั่วไป",
    urgentTasks: "งานเร่งด่วน",
    startTime: "ดาวน์โหลดเวลาเริ่มต้น",
    endTime: "ดาวน์โหลดเวลาสิ้นสุด"
  },
  hisDownloadTabelWidth: {
    tabelWidth1: "120px",
    tabelWidth2: "100x",
    tabelWidth3: "160px"
  },
  hisTips: {
    taskInfo: "งานกำลังดำเนินการอยู่และไม่สามารถลบออกได้",
    isDelete: "Delete or not",
    isSelect: "โปรดเลือกงาน",
    noSuccess: "สถานะการดาวน์โหลดงานไม่เสร็จสมบูรณ์",
    stateInfo: "ไม่ได้ตั้งค่างาน"
  },
  boxAddTask: {
    addTask: "เพิ่มงาน",
    selectVehicle: "เลือกยานพาหนะ",
    selectParameters: "เลือกพารามิเตอร์",
    carInfo: "ไม่มีการเลือกยานพาหนะในเวลาปัจจุบัน",
    tabelWidth: "110px",
    select: "ได้รับเลือก",
    selectDes: "ยานพาหนะ",
    operatingArea: "Operating area",
    terminalNumber: "หมายเลขเทอร์มินัล",
    brand: "ยี่ห้อ",
    model: "โมเดล",
    series: "ซีรี่ย์",
    projectCode: "Project code",
    modelName: "Model name",
    forCar: "สำหรับรถยนต์",
    ignites: "ติดไฟ",
    standardCar: "สำหรับรถยนต์",
    error: {
      selectTaskName: "โปรดป้อนชื่องาน",
      selectVehicle: "โปรดเลือกยานพาหนะ",
      selectStartTime: "โปรดเลือกเวลาเริ่มต้น",
      selectEndTime: "โปรดเลือกเวลาสิ้นสุด",
      selectDownloadType: "โปรดเลือกประเภทการดาวน์โหลด",
      selectTimes: "เวลาเริ่มต้นไม่เกินเวลาสิ้นสุด， โปรดเลือกอีกครั้ง"
    },
    parameters: {
      parameterName: "ชื่อพารามิเตอร์"
    },
    width1: "95px",
    width2: "110px"
  },
  tripvicel: {
    downOBD: "รวม",
    obdwidth: "110px",
    carInfo: "ไม่มีการเลือก OBD ในเวลาปัจจุบัน",
    selectDes: "OBD",
    samplingRate: "อัตราการสุ่มตัวอย่าง",
    errorsamplingRate: "โปรดป้อนอัตราการสุ่มตัวอย่าง",
    querytime: "เวลาดาวน์โหลด"
  }
} 
export default statistical